import React, { useState, useEffect } from "react";
import Navbar from "./component/navbar";
import Footer from "./component/footer";
import { useNavigate } from "react-router-dom";
import Data_phonenumber from "./pages/PhoneInData/Data_phone";
import Fancybox from "./component/Fancybox";
import { preload } from "react-dom";

export default function App() {
  const navigate = useNavigate();
  // Database
  const BannerImg = [
    {
      id: 1,
      img: "https://vmcmu.vet.cmu.ac.th/images/imageBanner/6_y2pxnD7Nti_u9u3.jpg",
    },
  ];

  const Phone_number = Data_phonenumber.Phone_number;
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isHovered, setIsHovered] = useState(false);
  const [isVisible, setIsVisible] = useState(false);
  const [inputValue, setInputValue] = useState("");
  const [filteredData, setFilteredData] = useState(Phone_number);

  // เปลี่ยนภาพอัตโนมัติทุก ๆ 5 วินาที
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) =>
        prevIndex === BannerImg.length - 1 ? 0 : prevIndex + 1
      );
    }, 5000); // เปลี่ยนภาพทุก ๆ 5 วินาที
    return () => clearInterval(interval);
  }, [BannerImg.length]);

  const handlePrev = () => {
    setCurrentIndex(
      currentIndex === 0 ? BannerImg.length - 1 : currentIndex - 1
    );
  };

  const handleNext = () => {
    setCurrentIndex((currentIndex + 1) % BannerImg.length);
  };
  const handleInputChange = (e) => {
    const value = e.target.value.trim();
    setInputValue(value);
    setIsVisible(value.length > 0);

    // กรองข้อมูลโดยไม่สนใจตัวพิมพ์เล็ก/ใหญ่ และค้นหาจากทุกตำแหน่งใน name
    const filtered = Data_phonenumber.Phone_number.filter((item) =>
      item.name.toLowerCase().includes(value.toLowerCase())
    );
    setFilteredData(filtered);
  };

  return (
    <>
      <Navbar />
      {/* Main section */}
      <div className="w-full ">
        {/* Banner section */}
        <div className="relative mx-auto overflow-hidden">
          {/* ภาพในคารูเซล */}
          <div
            className="flex transition-transform duration-500 ease-in-out"
            style={{ transform: `translateX(-${currentIndex * 100}%)` }}
          >
            {BannerImg.map((banner) => (
              <img
                key={banner.id}
                src={banner.img}
                alt={`Banner ${banner.id}`}
                className="w-full object-cover"
              />
            ))}
          </div>
          {/* ปุ่มนำทาง */}
          <button
            onClick={handlePrev}
            className="absolute top-1/2 left-4 transform -translate-y-1/2  hover:bg-white px-4 py-3 rounded-full shadow-lg text-gray-100/0 hover:text-black "
          >
            <i className="fa fa-chevron-left "></i>
          </button>
          <button
            onClick={handleNext}
            className="absolute top-1/2 right-4 transform -translate-y-1/2 hover:bg-white px-4 py-3 rounded-full shadow-lg text-gray-100/0 hover:text-black"
          >
            <i className="fa fa-chevron-right"></i>
          </button>
          {/* ตัวชี้สถานะ */}
          <div className="absolute bottom-4 left-1/2 transform -translate-x-1/2 flex space-x-2">
            {BannerImg.map((_, index) => (
              <div
                key={index}
                className={`w-3 h-3 rounded-full ${
                  index === currentIndex ? "bg-gray-800" : "bg-gray-400"
                }`}
                onClick={() => setCurrentIndex(index)}
              />
            ))}
          </div>
        </div>
        {/* Banner section */}
      </div>
      {/* content section */}
      <div className="px-5 py-3 max-w-7xl mx-auto h-full">
        <div className=" h-10 flex items-center overflow-hidden text-gray-600 border-b border-[#9e76b460]">
          <div
            className={`flex gap-20 whitespace-nowrap cursor-pointer ${
              isHovered ? "animate-marquee-paused" : "animate-marquee"
            }`}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
          >
            <span>
              <i className="fa fa-bullhorn text-[#9e76b4] mr-1"></i>
              มหาวิทยาลัยเชียงใหม่ โดยอธิการบดี ศาสตราจารย์ นายแพทย์ เรือโท
              ยงยุทธ สัจจวาณิชย์ (ดำรงตำแหน่งวันที่ 28 เมษายน พ.ศ.2518 ถึง 21
              มกราคม พ.ศ. 2520) ได้มีดำริที่จะมีคณะสัตวแพทยศาสตร์ขึ้นใน
              มหาวิทยาลัยเชียงใหม่ ซึ่งเป็นมหาวิทยาลัยส่วนภูมิภาค
              อธิการบดีได้ไปติดต่อพูดคุยกับสัตว์แพทย์หลายท่านเพื่อให้มาช่วยก่อตั้งคณะสัตวแพทย์ศาสตร์
              เช่นติดต่่อกับ รองศาสตราจารย์ ดร. นายสัตวแพทย์ ดำรง พฤกษราช
              แห่งภาควิชาจุลชีววิทยาทางสัตวแพทย์
              คณะสัตวแพทยศาสตร์มหาวิทยาลัยเกษตรศาสตร์
              โดยขณะนั้นได้มีการพบปะพูดคุยกัน เรื่องร่างหลักสูตรบ้าง
              แต่ระหว่างที่ดำเนินการอาจติดขัดเรื่องงบประมาณการดำเนินการจึงยังไม่สำเร็จ
              ต่อมาในสมัยอธิการบดี ศาสตราจารย์ นาวาอากาศเอก นายแพทย์ ตะวัน
              กันวานพงศ์ (ดำรงตำแหน่งสมัยที่ 2 วันที่ 21 มกราคม พ.ศ. 2522 ถึง 20
              มกราคม พ.ศ. 2524)
              มีการสนับสนุนให้มีการก่อตั้งคณะสัตวแพทยศาสตร์อีกครั้ง
              แต่ยังประสบปัญหาเรื่องงบประมาณ จึงยังไม่สามารถเริ่มดำเนินการได้
            </span>
            <span>
              <i className="fa fa-bullhorn text-[#9e76b4] mr-1"></i>
              มหาวิทยาลัยเชียงใหม่ โดยอธิการบดี ศาสตราจารย์ นายแพทย์ เรือโท
              ยงยุทธ สัจจวาณิชย์ (ดำรงตำแหน่งวันที่ 28 เมษายน พ.ศ.2518 ถึง 21
              มกราคม พ.ศ. 2520) ได้มีดำริที่จะมีคณะสัตวแพทยศาสตร์ขึ้นใน
              มหาวิทยาลัยเชียงใหม่ ซึ่งเป็นมหาวิทยาลัยส่วนภูมิภาค
              อธิการบดีได้ไปติดต่อพูดคุยกับสัตว์แพทย์หลายท่านเพื่อให้มาช่วยก่อตั้งคณะสัตวแพทย์ศาสตร์
              เช่นติดต่่อกับ รองศาสตราจารย์ ดร. นายสัตวแพทย์ ดำรง พฤกษราช
              แห่งภาควิชาจุลชีววิทยาทางสัตวแพทย์
              คณะสัตวแพทยศาสตร์มหาวิทยาลัยเกษตรศาสตร์
              โดยขณะนั้นได้มีการพบปะพูดคุยกัน เรื่องร่างหลักสูตรบ้าง
              แต่ระหว่างที่ดำเนินการอาจติดขัดเรื่องงบประมาณการดำเนินการจึงยังไม่สำเร็จ
              ต่อมาในสมัยอธิการบดี ศาสตราจารย์ นาวาอากาศเอก นายแพทย์ ตะวัน
              กันวานพงศ์ (ดำรงตำแหน่งสมัยที่ 2 วันที่ 21 มกราคม พ.ศ. 2522 ถึง 20
              มกราคม พ.ศ. 2524)
              มีการสนับสนุนให้มีการก่อตั้งคณะสัตวแพทยศาสตร์อีกครั้ง
              แต่ยังประสบปัญหาเรื่องงบประมาณ จึงยังไม่สามารถเริ่มดำเนินการได้
            </span>
            <span>
              <i className="fa fa-bullhorn text-[#9e76b4] mr-1"></i>
              มหาวิทยาลัยเชียงใหม่ โดยอธิการบดี ศาสตราจารย์ นายแพทย์ เรือโท
              ยงยุทธ สัจจวาณิชย์ (ดำรงตำแหน่งวันที่ 28 เมษายน พ.ศ.2518 ถึง 21
              มกราคม พ.ศ. 2520) ได้มีดำริที่จะมีคณะสัตวแพทยศาสตร์ขึ้นใน
              มหาวิทยาลัยเชียงใหม่ ซึ่งเป็นมหาวิทยาลัยส่วนภูมิภาค
              อธิการบดีได้ไปติดต่อพูดคุยกับสัตว์แพทย์หลายท่านเพื่อให้มาช่วยก่อตั้งคณะสัตวแพทย์ศาสตร์
              เช่นติดต่่อกับ รองศาสตราจารย์ ดร. นายสัตวแพทย์ ดำรง พฤกษราช
              แห่งภาควิชาจุลชีววิทยาทางสัตวแพทย์
              คณะสัตวแพทยศาสตร์มหาวิทยาลัยเกษตรศาสตร์
              โดยขณะนั้นได้มีการพบปะพูดคุยกัน เรื่องร่างหลักสูตรบ้าง
              แต่ระหว่างที่ดำเนินการอาจติดขัดเรื่องงบประมาณการดำเนินการจึงยังไม่สำเร็จ
              ต่อมาในสมัยอธิการบดี ศาสตราจารย์ นาวาอากาศเอก นายแพทย์ ตะวัน
              กันวานพงศ์ (ดำรงตำแหน่งสมัยที่ 2 วันที่ 21 มกราคม พ.ศ. 2522 ถึง 20
              มกราคม พ.ศ. 2524)
              มีการสนับสนุนให้มีการก่อตั้งคณะสัตวแพทยศาสตร์อีกครั้ง
              แต่ยังประสบปัญหาเรื่องงบประมาณ จึงยังไม่สามารถเริ่มดำเนินการได้
            </span>
          </div>
        </div>
        <div
          className="md:flex md:justify-center md:items-start md:gap-10
        grid grid-cols-1 gap-5 mt-5
        "
        >
          {/* Row1 */}
          <div className="flex flex-col w-full md:w-[120%]">
            {/* search */}
            <div className="relative mb-3">
              <div className="flex items-center justify-between">
                <input
                  type="search"
                  value={inputValue}
                  onChange={handleInputChange}
                  placeholder="ค้นหาเบอร์โทรภายในหน่วยงาน...."
                  className="bg-[#9e76b433] border border-[#9e76b4] text-gray-800 px-3 py-3 rounded-md w-full focus:outline-none focus:border-[#9e76b4] focus:border-2 placeholder:text-gray-400 "
                />
                <div
                  className={`absolute right-2 ${
                    isVisible ? "hidden" : "block"
                  }`}
                >
                  <button className="bg-[#9e76b4] text-white px-2 py-1 rounded-full">
                    <i className="fa fa-search text-white"></i>
                  </button>
                </div>
              </div>
            </div>
            {/* Search results */}
            <div className="relative">
              <div
                className={`absolute -top-3 left-0 right-0 bg-white border border-gray-300 rounded-md shadow-md z-10 p-3 transition-all duration-300 ease-in-out transform ${
                  isVisible
                    ? "opacity-100 translate-y-0"
                    : "opacity-0 -translate-y-5 hidden"
                }`}
              >
                <div className="overflow-y-scroll h-full max-h-[200px]">
                  <table className="w-full text-sm text-left rtl:text-right text-gray-500">
                    <thead className="text-xs text-gray-700 uppercase bg-gray-50  border-b">
                      <tr>
                        <th scope="col" className="px-2 py-2 bg-gray-50"></th>
                        <th scope="col" className="px-2 py-2 bg-gray-50">
                          ห้อง
                        </th>
                        <th scope="col" className="px-2 py-2 bg-gray-50">
                          เบอร์ติดต่อ
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {filteredData.length > 0 ? (
                        filteredData.map((item) => (
                          <>
                            <tr className="border-b border-gray-200">
                              <th
                                scope="row"
                                className="px-2 py-2 font-medium text-gray-900 whitespace-nowrap bg-gray-50"
                              >
                                {item.name}
                              </th>
                              <td class="px-2 py-2 bg-gray-50">{item.room}</td>
                              <td class="px-2 py-2 bg-gray-50">{item.phone}</td>
                            </tr>
                          </>
                        ))
                      ) : (
                        <>
                          <tr className="border-b border-gray-200">
                            <th
                              scope="row"
                              className="px-2 py-2 font-medium text-gray-900 whitespace-nowrap bg-gray-50"
                            >
                              ไม่พบข้อมูล
                            </th>
                            <td class="px-2 py-2">-</td>
                          </tr>
                        </>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            {/* Search results */}

            {/* End search */}
            {/* select button*/}
            <div className="flex flex-col gap-3">
              <h2 className="text-[#9e76b4]">เลือกหน่วยงาน</h2>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-x-4 gap-y-2">
                <button
                  onClick={() => navigate("/pages/general")}
                  className="bg-gradient-to-r from-[#9e76b4] to-[#5eafd2] text-white px-2 py-1 md:h-14 font-[500] md:text-2xl rounded-md shadow-md transition-all duration-300 hover:bg-gradient-to-r hover:from-[#5eafd2] hover:to-[#9e76b4]"
                >
                  <p>สารบรรณและเลขานุการ</p>
                </button>
                <button
                  onClick={() => navigate("/pages/academic")}
                  className="bg-gradient-to-r from-[#9e76b4] to-[#5eafd2] text-white px-2 py-1 md:h-14 font-[500] md:text-2xl rounded-md shadow-md transition-all duration-300 hover:bg-gradient-to-r hover:from-[#5eafd2] hover:to-[#9e76b4]"
                >
                  <p>ทรัพยากรบุคคล</p>
                </button>

                <button
                  onClick={() => navigate("/pages/bdi")}
                  className="bg-gradient-to-r from-[#9e76b4] to-[#5eafd2] text-white px-2 py-1 md:h-14 font-[500] md:text-2xl rounded-md shadow-md transition-all duration-300 hover:bg-gradient-to-r hover:from-[#5eafd2] hover:to-[#9e76b4]"
                >
                  <p>อาคารและยานพาหนะ</p>
                </button>

                <button
                  onClick={() => navigate("/pages/it")}
                  className="bg-gradient-to-r from-[#9e76b4] to-[#5eafd2] text-white px-2 py-1 md:h-14 font-[500] md:text-2xl rounded-md shadow-md transition-all duration-300 hover:bg-gradient-to-r hover:from-[#5eafd2] hover:to-[#9e76b4]"
                >
                  <p>เทคโนโลยีสารสนเทศ</p>
                </button>
              </div>
            </div>
            {/* End select button*/}

            {/* Calendar */}
            <div className="flex flex-col mt-3 gap-3">
              <h2 className="text-[#9e76b4]">Calendar Event</h2>
              <div className="shadow-md rounded-lg overflow-hidden">
                <iframe
                  src="https://calendar.google.com/calendar/embed?height=600&wkst=1&bgcolor=%23ffffff&ctz=Asia%2FBangkok&src=YTVmOTc5OTJiODFhMTFlY2NjMDEyZDgzYzMxMTcxY2YzNmNhYWFhYWNmZDhjNTdkNGFkOWFiZmEzYTRiZDAzY0Bncm91cC5jYWxlbmRhci5nb29nbGUuY29t&color=%233F51B5"
                  className="w-full h-[400px]"
                  frameborder="0"
                ></iframe>
              </div>
            </div>
            {/* End Calendar */}
          </div>
          {/* End Row1 */}

          {/* Row2 */}
          <div className="w-full md:w-1/2">
            <div className="flex flex-col gap-5 bg-slate-300 px-5 py-2 rounded-lg shadow-md h-[300px] mb-36 md:h-[720px] overflow-y-scroll custom-scrollbar">
              <div className="flex flex-col mr-auto  gap-2  w-full">
                {/* สารบรรณและเลขานุการ */}
                <h4 className="text-[#9e76b4] font-[600]">
                  สารบรรณและเลขานุการ
                </h4>

                <Fancybox
                  options={{
                    Toolbar: {
                      display: ["close"], // แสดงเฉพาะปุ่มปิด
                    },
                    Iframe: {
                      preload: false,
                      attr: {
                        sandbox: "allow-scripts allow-same-origin", // ปิดฟังก์ชันดาวน์โหลดและพิมพ์
                        allowfullscreen: "false", // ปิดการขยายเต็มจอ
                      },
                    },
                  }}
                >
                  <div className="flex flex-col gap-2">
                    <button
                      onClick={() =>
                        window.open("/IDP/view-TWc9PQ-YVdSdw.pdf", "_blank")
                      }
                      className="text-start bg-white text-[#9e76b4] transition-all duration-300 hover:bg-[#9e76b4] hover:text-white border border-gray-300 px-3 py-2 rounded-md w-full"
                    >
                      สมรรถนะตำแหน่งงาน
                    </button>
                    <button
                      onClick={() => navigate("/pages/general")}
                      className="text-start bg-white text-[#9e76b4] transition-all duration-300 hover:bg-[#9e76b4] hover:text-white border border-gray-300 px-3 py-2 rounded-md w-full"
                    >
                      มติที่ประชุม
                    </button>
                    <button
                      onClick={() => navigate("/pages/general")}
                      className="text-start bg-white text-[#9e76b4] transition-all duration-300 hover:bg-[#9e76b4] hover:text-white border border-gray-300 px-3 py-2 rounded-md w-full"
                    >
                      Knowledge Management
                    </button>
                  </div>
                </Fancybox>

                {/* สารบรรณและเลขานุการ */}

                {/* ทรัพยากรบุคคล */}
                <h4 className="text-[#9e76b4] font-[600]">ทรัพยากรบุคคล</h4>
                <button
                  onClick={() =>
                    window.open("https://mis.cmu.ac.th/cmumis/", "_blank")
                  }
                  className="text-start bg-white text-[#9e76b4] transition-all duration-300 hover:bg-[#9e76b4] hover:text-white border border-gray-300 px-3 py-2 rounded-md w-full"
                >
                  CMU MIS
                </button>
                <button
                  onClick={() =>
                    window.open("https://hr.mis.cmu.ac.th/login", "_blank")
                  }
                  className="text-start bg-white text-[#9e76b4] transition-all duration-300 hover:bg-[#9e76b4] hover:text-white border border-gray-300 px-3 py-2 rounded-md w-full"
                >
                  HR Portal
                </button>
                <button
                  onClick={() => navigate("/pages/academic/page")}
                  className="text-start bg-white text-[#9e76b4] transition-all duration-300 hover:bg-[#9e76b4] hover:text-white border border-gray-300 px-3 py-2 rounded-md w-full"
                >
                  การขอตำแหน่งทางวิชาการ
                </button>
                {/* ทรัพยากรบุคคล */}

                {/* เทคโนโลยีสารสนเทศ */}
                <h4 className="text-[#9e76b4] font-[600]">เทคโนโลยีสารสนเทศ</h4>
                <button
                  onClick={() =>
                    window.open("/ITS/cyber-security-cmu.pdf", "_blank")
                  }
                  className="text-start bg-white text-[#9e76b4] transition-all duration-300 hover:bg-[#9e76b4] hover:text-white border border-gray-300 px-3 py-2 rounded-md w-full"
                >
                  นโยบายรักษาความปลอดภัยไซเบอร์
                </button>
                <button
                  onClick={() => window.open("/ITS/SC.pdf", "_blank")}
                  className="text-start bg-white text-[#9e76b4] transition-all duration-300 hover:bg-[#9e76b4] hover:text-white border border-gray-300 px-3 py-2 rounded-md w-full"
                >
                  ระเบียบและข้อบังคับ
                </button>

                {/* เทคโนโลยีสารสนเทศ */}
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* content section */}

      {/* Main section */}

      <Footer />
    </>
  );
}
